var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('v-btn',{attrs:{"href":_vm.route,"target":"_blank","text":"","color":"background"}},[_c('v-icon',{attrs:{"size":"26"}},[_vm._v("mdi-github")])],1)}
var staticRenderFns = []

export { render, staticRenderFns }